import React, {useState} from 'react';
import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import {Route, Switch, useLocation} from "wouter";
import LessonPlannerSchedules from "./LessonPlannerSchedules";
import LessonPlannerLessonPlans from "./LessonPlannerLessonPlans";
import LessonPlanner from "./LessonPlanner";
import LessonPlannerWizard from "./wizard/LessonPlannerWizard";
import LessonPlannerLessonPlan from "./LessonPlannerLessonPlan";

const LessonPlannerManager = () => {
    const BASE_URL = '/web/ui/view/lessonStudio';

    const TABS = {
        LESSON_SCHEDULES: { val: 0, hash: 'lessonSchedules' },
        LESSON_PLANS: { val: 1, hash: 'lessonPlans' }
    };

    const [location, setLocation] = useLocation();

    const [activeTabKey, setActiveTabKey] = useState(TABS.LESSON_SCHEDULES.val);

    const handleChangeTab = (key) => {
        setActiveTabKey(key);
        const selectedTab = Object.values(TABS).find(tab => tab.val === parseInt(key));
        if (selectedTab) {
            const currentUrl = new URL(window.location.href);
            const queryString = currentUrl.search;
            setLocation(`/web/ui/view/lessonStudio/${selectedTab.hash}${queryString}`);
        }
    };

    return (
        <Switch>
            <Route path={`${BASE_URL}/lessonSchedules/schedule/:scheduleId`}>
                {(params) => <LessonPlanner scheduleId={params.scheduleId} />}
            </Route>
            <Route path={`${BASE_URL}/lessonPlans/new`}>
                <LessonPlannerWizard />
            </Route>
            <Route path={`${BASE_URL}/lessonPlans/plan/:planId`}>
                {(params) => <LessonPlannerLessonPlan planId={params.planId} />}
            </Route>
            <Tabs overrideKey={activeTabKey} variant="standard" onChange={handleChangeTab} contentClassName="margin-t--l" destroyOnHidden={true}>
                <Tab tab={
                    <span className={'tabText'}>Lesson Schedules</span>
                } key={TABS.LESSON_SCHEDULES.val}>
                    <LessonPlannerSchedules />
                </Tab>
                <Tab tab={
                    <span className={'tabText'}>Lesson Plans</span>
                } key={TABS.LESSON_PLANS.val}>
                    <LessonPlannerLessonPlans />
                </Tab>
            </Tabs>
        </Switch>
    );
};

export default LessonPlannerManager;
